import { render, staticRenderFns } from "./CbxTaxBasisAssessment.vue?vue&type=template&id=4a83ae2e&"
import script from "./CbxTaxBasisAssessment.vue?vue&type=script&lang=ts&"
export * from "./CbxTaxBasisAssessment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports